// import 'whatwg-fetch';
import { createAction } from 'redux-actions';
import ApplicationForAdmission from '../utils/ApplicationForAdmission/ApplicationForAdmission'


export const editApplicationForAdmission = createAction('EDIT_APPLICATION_FOR_ADMISSION', ApplicationForAdmission.edit);
export const getApplicationForAdmission = createAction('GET_APPLICATION_FOR_ADMISSION', ApplicationForAdmission.get);
export const setApplicationForAdmission = createAction('SET_APPLICATION_FOR_ADMISSION')
export const updateApplicationForAdmission = createAction('UPDATE_APPLICATION_FOR_ADMISSION', ApplicationForAdmission.update)
export const uploadApplicationForAdmissionStudImg = createAction('UPDATE_APPLICATION_FOR_ADMISSION_STUD_IMG', ApplicationForAdmission.uploadStudImg)


// WEBPACK FOOTER //
// ./src/dashboards_redux/actions/ApplicationForAdmissionAction.jsx